export class PessoaViagem {
    
    nome: string
    cpfCnpj: string
    dataNasc: string
    fone: string
    fone1: string
    email: string

    constructor() {
        this.nome = null;
        this.cpfCnpj = null;
        this.dataNasc = null;
        this.fone = null;
        this.fone1 = null;
        this.email = null;
    }
}